export const getters = {
  MAIN_INDICATORS: (state) => state.mainIndicators,
}
